var $24e660c5a5be82af$exports = {};
$24e660c5a5be82af$exports = {
    "(optional)": `(pasirenkama)`,
    "(required)": `(privaloma)`
};


export {$24e660c5a5be82af$exports as default};
//# sourceMappingURL=lt-LT.module.js.map
